import { matchPath } from 'react-router';

const { REACT_APP_STAGING_DOMAIN, REACT_APP_DOMAIN, NODE_ENV } = process.env;

export const isRoot = () => {
  return window.location.hostname.split('.').length === 2;
};

export const getRootDomain = () => {
  if (isRoot()) {
    return window.location.hostname;
  }

  return window.location.hostname
    .split('.')
    .splice(1)
    .join('.');
};

export const getSubdomain = () => {
  let hostname = window.location.hostname;

  if (NODE_ENV === 'development') {
    hostname = hostname.replace(REACT_APP_DOMAIN, REACT_APP_STAGING_DOMAIN);
  }

  return hostname;
};

export const popup = (url: string, title: string, width: number, height: number) => {
  const { top } = window;
  const y = top.outerHeight / 2 + top.screenY - height / 2;
  const x = top.outerWidth / 2 + top.screenX - width / 2;

  const newWindow = window.open(
    url,
    title,
    `scrollbars=yes, width=${width}, height=${height}, top=${String(y)}, left=${String(x)}`,
  );

  if (newWindow && newWindow.focus) {
    newWindow.focus();
  }
};

export const queryString = (params: object) => {
  return Object.keys(params)
    .map(key => `${key}=${params[key]}`)
    .join('&');
};

/**
 * Given source dimensions and maxWidth, return the scaled height and maxWidth
 * This isn't perfect because `maxHeight` is theoretically Infinity
 */
export const resizeImage = (srcWidth: number, srcHeight: number, maxWidth: number) => {
  const portraitRatio = +(srcHeight / srcWidth).toFixed(2);
  const height = Math.round(portraitRatio * maxWidth);

  return { height, width: maxWidth };
};

export const isPathMatch = (routes: string[], pathToTest: string) => {
  return routes.some(routeToTest => {
    const matchedPath = matchPath(pathToTest, { path: routeToTest, exact: true, strict: true });
    return !!matchedPath;
  });
};

export const isEven = (index: number) => index % 2 === 0;
